import { BrowserRouter, Route,Routes } from 'react-router-dom';
import './App.css';
import './components/style.css';
import HomePage from './components/HomePage';
import Layout from './components/Layout';
import Trackingdetails from './components/Trackingdetails';
function App() {
  return (
    <>
   

   <BrowserRouter>
      <Routes>
          <Route path="/" element={<Layout/>}>
          <Route index element={<HomePage/>} />
          <Route path="/tracking/:conNumber" element={<Trackingdetails/>} />
          
        </Route>
      </Routes>
    </BrowserRouter>
   
    </>
  );
}

export default App;
